
export const GCookieConfirmToastId = 'gCookieConfirmToast';
export const GCookieConfirmToastClass = 'g-cookie-confirm-toast';


export const ContentWrap = 'g-cookie-content';
export const BtnWrap = 'g-cookie-btn-wrap';
export const Btn = 'g-cookie-btn';
export const BtnApply = 'g-cookie-btn-apply';
export const BtnApplyOptional = 'g-cookie-btn-apply-optional';
export const BtnDeny = 'g-cookie-btn-deny';
export const BtnConfig = 'g-cookie-btn-config';
export const GCookieConfirmDimmedId = 'gCookieConfirmDimmed';
export const GCookieConfirmDimmedClass = 'g-cookie-confirm-dimmed';
export const IsActive= 'is-active';

// ConfirmToast 탬플릿
export function getConfirmToastTemplate(textData: ConfirmToastTextData, zIndex?: number): string {
  return `
  <div id="${GCookieConfirmDimmedId}" class="${GCookieConfirmDimmedClass}" style="${zIndex ? `z-index:${zIndex}` : ''}"></div>
  <div id="${GCookieConfirmToastId}" class="${GCookieConfirmToastClass}-wrap" style="${zIndex ? `z-index:${zIndex + 1}` : ''}">
    <div class="${GCookieConfirmToastClass}-top">
      <div class="${ContentWrap}">
        ${textData.content}
      </div>
    </div>
    <div class="${GCookieConfirmToastClass}-bottom">
      <div class="${BtnWrap}">
        <div class="${BtnWrap}-left">
          <div class="${Btn} ${BtnConfig}">
            <svg data-dark-mode="light" width="16" height="16" xmlns="http://www.w3.org/2000/svg">
              <path d="M9.033 1a.5.5 0 0 1 .442.265l.587 1.099c.657.24 1.26.593 1.787 1.033l1.247-.042a.5.5 0 0 1 .45.25l1.033 1.79a.5.5 0 0 1-.009.514l-.658 1.06a6.038 6.038 0 0 1 0 2.063l.658 1.059a.5.5 0 0 1 .047.431l-.038.083-1.033 1.79a.5.5 0 0 1-.36.244l-.09.006-1.247-.042c-.526.44-1.13.793-1.787 1.033l-.587 1.1a.5.5 0 0 1-.35.256L9.032 15H6.967a.5.5 0 0 1-.391-.189l-.05-.076-.587-1.098a5.994 5.994 0 0 1-1.788-1.034l-1.247.042a.5.5 0 0 1-.397-.176l-.053-.074-1.033-1.79a.5.5 0 0 1-.032-.433l.04-.081.66-1.058a6.038 6.038 0 0 1 0-2.066l-.66-1.058a.5.5 0 0 1-.008-.514l1.033-1.79a.5.5 0 0 1 .45-.25l1.247.042A5.994 5.994 0 0 1 5.94 2.363l.586-1.098A.5.5 0 0 1 6.967 1h2.066zM8 5a3 3 0 1 0 0 6 3 3 0 0 0 0-6z" fill="#FFF" fill-rule="evenodd" fill-opacity=".38"/>
            </svg>
            <svg data-dark-mode="dark" width="16" height="16" xmlns="http://www.w3.org/2000/svg">
              <path d="M9.033 1a.5.5 0 0 1 .442.265l.587 1.099c.657.24 1.26.593 1.787 1.033l1.247-.042a.5.5 0 0 1 .45.25l1.033 1.79a.5.5 0 0 1-.009.514l-.658 1.06a6.038 6.038 0 0 1 0 2.063l.658 1.059a.5.5 0 0 1 .047.431l-.038.083-1.033 1.79a.5.5 0 0 1-.36.244l-.09.006-1.247-.042c-.526.44-1.13.793-1.787 1.033l-.587 1.1a.5.5 0 0 1-.35.256L9.032 15H6.967a.5.5 0 0 1-.391-.189l-.05-.076-.587-1.098a5.994 5.994 0 0 1-1.788-1.034l-1.247.042a.5.5 0 0 1-.397-.176l-.053-.074-1.033-1.79a.5.5 0 0 1-.032-.433l.04-.081.66-1.058a6.038 6.038 0 0 1 0-2.066l-.66-1.058a.5.5 0 0 1-.008-.514l1.033-1.79a.5.5 0 0 1 .45-.25l1.247.042A5.994 5.994 0 0 1 5.94 2.363l.586-1.098A.5.5 0 0 1 6.967 1h2.066zM8 5a3 3 0 1 0 0 6 3 3 0 0 0 0-6z" fill="#000" fill-rule="evenodd" fill-opacity=".45"/>
            </svg>
            ${textData.BtnSetting}
          </div>
        </div>
        <div class="${BtnWrap}-right">
          <div class="${Btn} ${BtnDeny}">${textData.BtnDeny}</div>
          <div class="${Btn} ${BtnApplyOptional}">${textData.BtnApplyOptional}</div>
          <div class="${Btn} ${BtnApply}">${textData.BtnApply}</div>
        </div>
    </div>
    </div>
  </div>
`;
}

